import Header from '../components/Header'
import Menu from '../components/Menu'
import { FaInstagram, FaLink, FaRegCalendarAlt, FaRegClock } from 'react-icons/fa'
import { BiCalendarStar, BiEditAlt } from "react-icons/bi";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useAllContext } from '../context/AllContext';
import { FaXTwitter } from "react-icons/fa6";
import axios from 'axios';
import { toast } from 'react-toastify';

const MyProfile = () => {
    const { t } = useTranslation();

    const limitsUser = JSON.parse(localStorage.getItem('limitsUser'));
    const { getUserDetails, userDetails,
        getAllUserPosts, allUserPosts
     } = useAllContext()

    // image
    const [image, setImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [errorImage, setErrorImage] = useState(null);

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

    const handleFile = (file) => {
        if (!file) return;

        if (!allowedTypes.includes(file.type)) {
            setImage(null);
            setPreviewUrl(null);
            setErrorImage("Only JPG, JPEG, PNG, or WEBP images are allowed.");
            return;
        }

        setErrorImage(null);
        setImage(file);
        setPreviewUrl(URL.createObjectURL(file));
    };

    const handleFileChange = (e) => {
        handleFile(e.target.files[0]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        handleFile(e.dataTransfer.files[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const formImageUpdate = async (e) => {
        e.preventDefault();

        if (!image) {
            setErrorImage("Please select an image to upload.");
            return;
        }

        const formData = new FormData();
        formData.append('profileImage', image);
        formData.append('userId', limitsUser?._id);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/UserProfileUpdate`, formData, {
                headers: {
                    Authorization: `${limitsUser.token}`
                }
            })
            const data = await response.data

            if(data.status === 1){
                toast.success(data.message)
                getUserDetails(limitsUser.token, limitsUser._id)
                document.getElementById('imageModal').querySelector('.btn-close').click();
                setErrorImage("");
                setImage(null);
                setPreviewUrl(null);
            } else {
                toast.error(data.message)
            }

        } catch (error) {
            console.log('Error:', error.response.data.message);
            toast.error(error.response.data.message)
        }
    };

    // bio
    const [profileBio, setProfileBio] = useState("");
    const [errorBio, setErrorBio] = useState("");

    const formBioUpdate= async (e) => {
        e.preventDefault();

        if (!profileBio) {
            setErrorBio("Please select Profile Bio.");
            return;
        }

        const apiData = {
            userId: limitsUser?._id,
            bio: profileBio
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/UserBioUpdate`, apiData, {
                headers: {
                    Authorization: `${limitsUser.token}`
                }
            })
            const data = await response.data

            if(data.status === 1){
                toast.success(data.message)
                getUserDetails(limitsUser.token, limitsUser._id)
                document.getElementById('bioModal').querySelector('.btn-close').click();
                setProfileBio("");
                setErrorBio("");
            } else {
                toast.error(data.message)

            }

        } catch (error) {
            console.log('Error:', error.response.data.message);
            toast.error(error.response.data.message)
        }
    };

    useEffect(() => {
        if (userDetails) {
            setProfileBio(userDetails.bio)
        }
    }, [userDetails])

    useEffect(() => {
        if (limitsUser) {
            getUserDetails(limitsUser.token, limitsUser._id)
            getAllUserPosts(limitsUser.token, limitsUser._id)
        }
    }, [])
    
    return (
        <>
            <div className='main-content'>
                <Header page={"profile3"} title={"My Profile"} backpage={'/'} />

                <div className='padding2'>
                    <div className='container'>
                        <div className='my-profile mb-5'>
                            <div className='text-center'>
                                <div className='position-relative d-inline-block'>
                                    {
                                        userDetails?.profileImage ? userDetails.profileImage.split('/')[0] === "uploads" ? <img src={`${process.env.REACT_APP_IMAGES_URL}/${userDetails?.profileImage}`} crossOrigin="anonymous" className='img-fluid img1 d-block mx-auto' alt="" />
                                        : <img src={`${userDetails?.profileImage}`} className='img-fluid img1 d-block mx-auto' alt="" />
                                        : <img src={require('../assets/images/profile.png')} className='img-fluid img1 d-block mx-auto' alt="" />
                                    }
                                    
                                    <Link to="" data-bs-toggle="modal" data-bs-target="#imageModal" className='link2 position-absolute bottom-0 end-0'><BiEditAlt className="fs-5" /></Link>
                                </div>
                            </div>
                            <div className='text-center mt-4'>
                                <div className='position-relative'>
                                    <h5 className='mb-1'>{userDetails?.username}</h5>
                                    <h6 className='fs-12 mb-3'>{userDetails?.bio ? userDetails?.bio : "Add Profile bio"}</h6>
                                    <Link to="" data-bs-toggle="modal" data-bs-target="#bioModal" className='link2 position-absolute end-0 top-50 translate-middle-y'><BiEditAlt className="ms-1 align-middle fs-5 float-end" /></Link>
                                </div>

                                <div className='mt-3 mb-4 d-flex justify-content-center align-items-center'>
                                    <div className='w-100'>
                                        <h6 className='fw-semibold text-white mb-1'>{userDetails?.country ? userDetails.country : "-"}</h6>
                                        <h6 className='mb-0 fs-12'>Country</h6>
                                    </div>
                                    <div className='w-100'>
                                        <h6 className='fw-semibold text-white mb-1'>29</h6>
                                        <h6 className='mb-0 fs-12'>Uploads</h6>
                                    </div>
                                    <div className='w-100'>
                                        <h6 className='fw-semibold text-white mb-1'>5932</h6>
                                        <h6 className='mb-0 fs-12'>Views</h6>
                                    </div>
                                </div>
                                {
                                    userDetails?.website_link && <h6 className='fs-12 mb-2 text-nowrap ellipsis1'><Link to={userDetails?.website_link} target='_blank'><FaLink className='me-1 align-middle' /><span className='align-middle'>{userDetails?.website_link}</span></Link></h6>
                                }
                                {
                                    userDetails?.instagram_link && <h6 className='fs-12 mb-2 text-nowrap ellipsis1'><Link to={userDetails?.instagram_link} target='_blank'><FaInstagram className='me-1 align-middle' /><span className='align-middle'>{userDetails?.instagram_link}</span></Link></h6>
                                }
                                {
                                    userDetails?.twitter_link && <h6 className='fs-12 mb-2 text-nowrap ellipsis1'><Link to={userDetails?.twitter_link} target='_blank'><FaXTwitter className='me-1 align-middle' /><span className='align-middle'>{userDetails?.twitter_link}</span></Link></h6>
                                }
                                
                                {/* <h6 className='fs-12 mb-2 text-nowrap ellipsis1'></h6> */}
                            </div>
                        </div>
                        <div className='mt-5'>
                            <div className='text-end mb-2'>
                                <Link to={'/add-post'} className='btn btn1 btn-orange'>New Post</Link>
                            </div>
                            <ul className="nav nav-tabs nav2 border-0 mb-4 flex-nowrap" id="myTab" role="tablist">
                                <li className="nav-item w-100" role="presentation">
                                    <button className="nav-link active" id="one-tab" data-bs-toggle="tab" data-bs-target="#one" type="button" role="tab" aria-controls="one" aria-selected="true"><BiCalendarStar className='align-middle me-2' /><span className='align-middle'>Posts</span></button>
                                </li>
                                <li className="nav-item w-100" role="presentation">
                                    <button className="nav-link" id="two-tab" data-bs-toggle="tab" data-bs-target="#two" type="button" role="tab" aria-controls="two" aria-selected="false"><BiCalendarStar className='align-middle me-2' /><span className='align-middle'>Events</span></button>
                                </li>
                            </ul>

                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="one" role="tabpanel" aria-labelledby="one-tab">
                                    <div>
                                        {
                                            allUserPosts ? <div className="masonry" style={{ columnCount: 3, columnGap: '1rem' }}>
                                                {
                                                    allUserPosts?.map((items) => {
                                                        return <Link to={`/post-details/${items._id}`} key={items._id}><img
                                                            src={`${process.env.REACT_APP_IMAGES_URL}/${items.image}`}
                                                            crossOrigin="anonymous"
                                                            alt="img"
                                                            className="img-fluid rounded mb-3 w-100"
                                                        /></Link>
                                                    })
                                                }
                                            </div>
                                            : <div className='text-center mt-5'><p className=''>You have not posted anything yet</p></div>
                                        }
                                        {/* <div className="masonry" style={{ columnCount: 3, columnGap: '1rem' }}>
                                            <img
                                                src={require('../assets/images/img_2.jpg')}
                                                alt="img"
                                                className="img-fluid rounded mb-3 w-100"
                                            />
                                        </div> */}
                                    </div>

                                </div>

                                <div className="tab-pane fade" id="two" role="tabpanel" aria-labelledby="two-tab">
                                    <div className='battle-box d-flex'>
                                        <div className='img'>
                                            <img src={require('../assets/images/user-img.png')} crossOrigin="anonymous" className="img-fluid img1" alt="" />
                                        </div>
                                        <div className='txt align-self-center'>
                                            <h6 className='mb-2 text-white fw-medium'>Ultricies turpis semper tortor curae event name</h6>
                                            <h6 className='mb-0 fs-12 fw-medium'>
                                                <span className='me-3'>Type: Loremipsum</span>
                                                <FaRegCalendarAlt className='align-bottom fs-6 me-1' /> <span className='align-bottom me-3'>29 Jul 2024</span>
                                                <FaRegClock className='align-bottom fs-6 me-1' /> <span className='align-bottom'>12pm - 7pm</span>
                                            </h6>
                                            <div className='d-flex align-items-center participants-plus calander-participants mt-2'>
                                                <div className='d-flex me-2'>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                </div>
                                                {/* <div className='d-flex me-2'>
                                                    {
                                                        items?.participants?.slice(0, 5).map((items, ind) => (
                                                            <div key={ind} className='img1'>
                                                                {items.user.profileImage !== "" ? (
                                                                    <img src={`${process.env.REACT_APP_IMAGES_URL}/${items.user.profileImage}`} crossOrigin="anonymous" className='img-fluid' alt="" />
                                                                ) : (
                                                                    <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                                )}
                                                            </div>
                                                        ))
                                                    }
                                                </div> */}
                                                <div>
                                                    <p className='mb-0 fs-12 fw-medium'>+5 Participants</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='battle-box d-flex'>
                                        <div className='img'>
                                            <img src={require('../assets/images/user-img.png')} crossOrigin="anonymous" className="img-fluid img1" alt="" />
                                        </div>
                                        <div className='txt align-self-center'>
                                            <h6 className='mb-2 text-white fw-medium'>Ultricies turpis semper tortor curae event name</h6>
                                            <h6 className='mb-0 fs-12 fw-medium'>
                                                <span className='me-3'>Type: Loremipsum</span>
                                                <FaRegCalendarAlt className='align-bottom fs-6 me-1' /> <span className='align-bottom me-3'>29 Jul 2024</span>
                                                <FaRegClock className='align-bottom fs-6 me-1' /> <span className='align-bottom'>12pm - 7pm</span>
                                            </h6>
                                            <div className='d-flex align-items-center participants-plus calander-participants mt-2'>
                                                <div className='d-flex me-2'>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                </div>
                                                {/* <div className='d-flex me-2'>
                                                    {
                                                        items?.participants?.slice(0, 5).map((items, ind) => (
                                                            <div key={ind} className='img1'>
                                                                {items.user.profileImage !== "" ? (
                                                                    <img src={`${process.env.REACT_APP_IMAGES_URL}/${items.user.profileImage}`} crossOrigin="anonymous" className='img-fluid' alt="" />
                                                                ) : (
                                                                    <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                                )}
                                                            </div>
                                                        ))
                                                    }
                                                </div> */}
                                                <div>
                                                    <p className='mb-0 fs-12 fw-medium'>+5 Participants</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='battle-box d-flex'>
                                        <div className='img'>
                                            <img src={require('../assets/images/user-img.png')} crossOrigin="anonymous" className="img-fluid img1" alt="" />
                                        </div>
                                        <div className='txt align-self-center'>
                                            <h6 className='mb-2 text-white fw-medium'>Ultricies turpis semper tortor curae event name</h6>
                                            <h6 className='mb-0 fs-12 fw-medium'>
                                                <span className='me-3'>Type: Loremipsum</span>
                                                <FaRegCalendarAlt className='align-bottom fs-6 me-1' /> <span className='align-bottom me-3'>29 Jul 2024</span>
                                                <FaRegClock className='align-bottom fs-6 me-1' /> <span className='align-bottom'>12pm - 7pm</span>
                                            </h6>
                                            <div className='d-flex align-items-center participants-plus calander-participants mt-2'>
                                                <div className='d-flex me-2'>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                    <div className='img1'>
                                                        <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                    </div>
                                                </div>
                                                {/* <div className='d-flex me-2'>
                                                    {
                                                        items?.participants?.slice(0, 5).map((items, ind) => (
                                                            <div key={ind} className='img1'>
                                                                {items.user.profileImage !== "" ? (
                                                                    <img src={`${process.env.REACT_APP_IMAGES_URL}/${items.user.profileImage}`} crossOrigin="anonymous" className='img-fluid' alt="" />
                                                                ) : (
                                                                    <img src={require('../assets/images/user-img.png')} className='img-fluid' alt="" />
                                                                )}
                                                            </div>
                                                        ))
                                                    }
                                                </div> */}
                                                <div>
                                                    <p className='mb-0 fs-12 fw-medium'>+5 Participants</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Menu />

                {/* <!-- Modal --> */}
                <div className="modal modal1 fade" id="bioModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" style={{ 'maxWidth': '600px' }}>
                        <div className="modal-content">
                            <div className="modal-header border-0 pb-0 pt-4 px-4">
                                {/* <h5 className="modal-title" id="staticBackdropLabel">Modal title</h5> */}
                                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body p-4 p-md-5 scrollbar">
                                <form action="" className='form form1' onSubmit={formBioUpdate}>
                                    <div className='mb-3'>
                                        <h5 className='mb-3 text-white'>Profile Bio</h5>
                                        <input type="text" className="form-control" name="profileBio"
                                        value={profileBio}
                                        onChange={(e) => {setProfileBio(e.target.value)}} />
                                        {errorBio && <p className="error-text">{errorBio}</p> }
                                    </div>
                                    <div className='mt-4 text-center'>
                                        <button type='submit' className='btn btn1 mt-4'>{t("Update")}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal modal1 fade" id="imageModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" style={{ 'maxWidth': '600px' }}>
                        <div className="modal-content">
                            <div className="modal-header border-0 pb-0 pt-4 px-4">
                                {/* <h5 className="modal-title" id="staticBackdropLabel">Modal title</h5> */}
                                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body p-4 p-md-5 scrollbar">
                                <form action="" className='form form1' onSubmit={formImageUpdate}>
                                    <h5 className='mb-3 text-white'>{t("Profile Image")}</h5>
                                    <div className="image-drag1">
                                        <div
                                            className="align-items-center d-flex flex-column justify-content-center p-4 rounded-4 img-box"
                                            onDrop={handleDrop}
                                            onDragOver={handleDragOver}
                                            onClick={() => document.getElementById('fileInput').click()}
                                        >
                                            {previewUrl ? (
                                                <img
                                                    src={previewUrl}
                                                    alt="Preview"
                                                    className="img-fluid rounded-circle img1"
                                                />
                                            ) : (
                                                <div>
                                                    <i className="bi bi-cloud-arrow-up display-4 text-primary"></i>
                                                    <p className="mt-2">Drag & drop or click to upload profile image</p>
                                                </div>
                                            )}
                                        </div>

                                        <input
                                            type="file"
                                            id="fileInput"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    {errorImage && <p className="error-text">{errorImage}</p> }
                                    <div className='mt-4 text-center'>
                                        <button type='submit' className='btn btn1 mt-4'>{t("Update")}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyProfile
